// ./src/contexts/BudgetItemsContext/BudgetItemsContext.tsx
//
// Thin context wrapper around the useBudgetItems hook. All derived data lives in
// the hook itself. See TasksContext for the pattern.

import React, { createContext, useContext } from "react";

import { useBudgetItems, UseBudgetItemsOptions, UseBudgetItemsReturn } from "@/hooks/useBudgetItems";

const BudgetItemsContext = createContext<UseBudgetItemsReturn | null>(null);

export interface BudgetItemsProviderProps extends UseBudgetItemsOptions {
  children: React.ReactNode;
}

export const BudgetItemsProvider: React.FC<BudgetItemsProviderProps> = ({ children, ...options }) => {
  const value = useBudgetItems(options);

  return <BudgetItemsContext.Provider value={value}>{children}</BudgetItemsContext.Provider>;
};

export const useBudgetItemsContext = (): UseBudgetItemsReturn => {
  const context = useContext(BudgetItemsContext);

  if (!context) {
    throw new Error(
      "useBudgetItemsContext must be used within a <BudgetItemsProvider>. " +
        "Wrap your component tree with <BudgetItemsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalBudgetItemsContext = (): UseBudgetItemsReturn | null => {
  return useContext(BudgetItemsContext);
};
